module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.detailData.category_status == 10 || _vm.task_id == 0) ? _c('div', {
    staticClass: "button-list"
  }, [_c('div', {
    staticClass: "front-btn green",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    staticClass: "front-btn green",
    on: {
      "click": _vm.release
    }
  }, [_vm._v("发布")])]) : _vm._e(), _vm._v(" "), (_vm.buType == 1 && _vm.detailData.category_status == 20 && _vm.detailData.process_status == 204) ? _c('div', {
    staticClass: "button-list"
  }, [_c('div', {
    staticClass: "front-btn green",
    on: {
      "click": _vm.review_complete
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('div', {
    staticClass: "front-btn",
    on: {
      "click": function($event) {
        _vm.pop.review_rejectFlag = true
      }
    }
  }, [_vm._v("不通过")])]) : _vm._e(), _vm._v(" "), (_vm.buType == 1 && _vm.detailData.category_status == 20 && _vm.detailData.process_status == 205) ? _c('div', {
    staticClass: "button-list"
  }, [_c('div', {
    staticClass: "front-btn green",
    on: {
      "click": _vm.cancel_agree
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('div', {
    staticClass: "front-btn",
    on: {
      "click": function($event) {
        _vm.pop.cancelRejectFlag = true
      }
    }
  }, [_vm._v("不通过")])]) : _vm._e(), _vm._v(" "), (_vm.buType == 1 && _vm.detailData.category_status == 20 && _vm.detailData.process_status == 202) ? _c('div', {
    staticClass: "button-list"
  }, [_c('div', {
    staticClass: "front-btn red",
    on: {
      "click": function($event) {
        _vm.pop.reportFlag = true
      }
    }
  }, [_vm._v("投诉")]), _vm._v(" "), _c('div', {
    staticClass: "front-btn red",
    on: {
      "click": _vm.stop_task
    }
  }, [_vm._v("终止")])]) : _vm._e(), _vm._v(" "), (_vm.buType == 2 && _vm.detailData.category_status == 20 && _vm.detailData.process_status == 201) ? _c('div', {
    staticClass: "button-list"
  }, [_c('div', {
    staticClass: "front-btn green",
    on: {
      "click": _vm.receive
    }
  }, [_vm._v("接收")]), _vm._v(" "), _c('div', {
    staticClass: "front-btn red",
    on: {
      "click": function($event) {
        _vm.pop.refuseFlag = true
      }
    }
  }, [_vm._v("拒绝")])]) : _vm._e(), _vm._v(" "), (_vm.buType == 2 && _vm.detailData.category_status == 20 && _vm.detailData.process_status == 203) ? _c('div', {
    staticClass: "button-list"
  }, [_c('div', {
    staticClass: "front-btn green",
    on: {
      "click": _vm.review
    }
  }, [_vm._v("提交验收")]), _vm._v(" "), _c('div', {
    staticClass: "front-btn red",
    on: {
      "click": function($event) {
        _vm.pop.cancelFlag = true
      }
    }
  }, [_vm._v("申请取消")])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "拒绝任务",
      "visible": _vm.pop.refuseFlag
    },
    on: {
      "open": function($event) {
        _vm.openFocus('area_refuse')
      },
      "close": function($event) {
        _vm.pop.refuseReason = ''
      },
      "update:visible": function($event) {
        _vm.$set(_vm.pop, "refuseFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("任务编号：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.detailData.code))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("任务名称：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.detailData.task_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("拒绝原因：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.refuseReason),
      expression: "pop.refuseReason"
    }],
    ref: "area_refuse",
    class: {
      'z-error': _vm.pop.refuseTip
    },
    attrs: {
      "id": "area_refuse"
    },
    domProps: {
      "value": (_vm.pop.refuseReason)
    },
    on: {
      "focus": function($event) {
        _vm.pop.refuseTip = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "refuseReason", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pop.refuseTip),
      expression: "pop.refuseTip"
    }],
    staticClass: "tip"
  }, [_vm._v("请输入拒绝原因")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pop.refuseFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm_refuse
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "任务投诉",
      "visible": _vm.pop.reportFlag
    },
    on: {
      "open": function($event) {
        _vm.openFocus('area_report')
      },
      "close": function($event) {
        _vm.pop.reportReason = ''
      },
      "update:visible": function($event) {
        _vm.$set(_vm.pop, "reportFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("任务编号：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.detailData.code))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("任务名称：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.detailData.task_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("投诉原因：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.reportReason),
      expression: "pop.reportReason"
    }],
    ref: "area_report",
    class: {
      'z-error': _vm.pop.reportTip
    },
    domProps: {
      "value": (_vm.pop.reportReason)
    },
    on: {
      "focus": function($event) {
        _vm.pop.reportTip = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "reportReason", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pop.reportTip),
      expression: "pop.reportTip"
    }],
    staticClass: "tip"
  }, [_vm._v("请输入投诉原因")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pop.reportFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm_report
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "任务取消",
      "visible": _vm.pop.cancelFlag
    },
    on: {
      "open": function($event) {
        _vm.openFocus('area_cancel')
      },
      "close": function($event) {
        _vm.pop.cancelReason = ''
      },
      "update:visible": function($event) {
        _vm.$set(_vm.pop, "cancelFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("任务编号：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.detailData.code))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("任务名称：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.detailData.task_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("取消原因：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.cancelReason),
      expression: "pop.cancelReason"
    }],
    ref: "area_cancel",
    class: {
      'z-error': _vm.pop.cancelTip
    },
    domProps: {
      "value": (_vm.pop.cancelReason)
    },
    on: {
      "focus": function($event) {
        _vm.pop.cancelTip = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "cancelReason", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pop.cancelTip),
      expression: "pop.cancelTip"
    }],
    staticClass: "tip"
  }, [_vm._v("请输入取消原因")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pop.cancelFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm_cancel
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "拒绝验收",
      "visible": _vm.pop.review_rejectFlag
    },
    on: {
      "open": function($event) {
        _vm.openFocus('area_review')
      },
      "close": function($event) {
        _vm.pop.review_rejectReason = ''
      },
      "update:visible": function($event) {
        _vm.$set(_vm.pop, "review_rejectFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("任务编号：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.detailData.code))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("任务名称：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.detailData.task_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("拒绝原因：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.review_rejectReason),
      expression: "pop.review_rejectReason"
    }],
    ref: "area_review",
    class: {
      'z-error': _vm.pop.review_rejectTip
    },
    domProps: {
      "value": (_vm.pop.review_rejectReason)
    },
    on: {
      "focus": function($event) {
        _vm.pop.review_rejectTip = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "review_rejectReason", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pop.review_rejectTip),
      expression: "pop.review_rejectTip"
    }],
    staticClass: "tip"
  }, [_vm._v("请输入拒绝原因")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pop.review_rejectFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm_review_reject
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "拒绝取消",
      "visible": _vm.pop.cancelRejectFlag
    },
    on: {
      "open": function($event) {
        _vm.openFocus('area_cancel')
      },
      "close": function($event) {
        _vm.pop.cancelRejectReason = ''
      },
      "update:visible": function($event) {
        _vm.$set(_vm.pop, "cancelRejectFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("任务编号：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.detailData.code))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("任务名称：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.detailData.task_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("拒绝原因：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.cancelRejectReason),
      expression: "pop.cancelRejectReason"
    }],
    ref: "area_cancel",
    class: {
      'z-error': _vm.pop.cancelRejectTip
    },
    domProps: {
      "value": (_vm.pop.cancelRejectReason)
    },
    on: {
      "focus": function($event) {
        _vm.pop.cancelRejectTip = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "cancelRejectReason", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pop.cancelRejectTip),
      expression: "pop.cancelRejectTip"
    }],
    staticClass: "tip"
  }, [_vm._v("请输入拒绝原因")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pop.cancelRejectFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm_cancel_reject
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-48ca66fa!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/task/detailTask/process-btn.vue
// module id = 737
// module chunks = 1